
import { defineComponent, PropType } from "vue";
import Expand from "../images/Expand.svg";

type Option = { label: string, value: unknown };

export default defineComponent({
  props: {
    modelValue: { type: Object as PropType<Option>, default: null },
    name: { type: String, default: "" },
    options: { type: Array as PropType<Option[]>, required: true },
    block: { type: Boolean, default: false },
    nullable: { type: Boolean, default: false },
  },
  emits: [
    "update:modelValue",
  ],
  data: () => ({
    Expand,
  }),
  computed: {
    value(): number | null {
      if (!this.modelValue) return -1;
      return this.options.findIndex((option) => option.label === this.modelValue.label);
    },
  },
  methods: {
    onChange(ix: number): void {
      if (ix === -1) {
        this.$emit("update:modelValue", null);
      } else {
        this.$emit("update:modelValue", this.options[ix]);
      }
    },
  },
});
